import React from "react";
import { Modal } from "react-bootstrap";
import PropTypes from "prop-types";
import close from "../../assets/svgs/close.svg";
import logout from "../../assets/svgs/log-out.svg";
import "../../assets/css/modal.css";
import "./Step.css";

const PopUp = ({ show, closeModal, text, sub, delivery_fee, small_order_fee, method, gst, total, onProceed }) => {
  const handleClick = () => {
    if (onProceed) {
      onProceed();
    }
    closeModal();
  }

  return (
    <Modal
      show={show}
      onHide={closeModal}
      dialogClassName="modal-smd maxwidth500"
      centered
    >
      {
        !text ?
          <div>
            <Modal.Header closeButton className="border-bottom">
              <Modal.Title>Billing Details</Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <table className="billing-table w-100">
                <tbody>
                  <tr>
                    <td>Sub Total:</td>
                    <td className="text-right" data-testid="sub_total">
                      {sub && !isNaN(sub) ? `$ ${parseFloat(sub).toFixed(2)}` : "$ 0"}
                    </td>
                  </tr>

                  {method === 1 && (
                    <tr>
                      <td>Delivery Charge:</td>
                      <td className="text-right" data-testid="final_delivery_charge">
                        {delivery_fee && !isNaN(delivery_fee) ? `$ ${parseFloat(delivery_fee).toFixed(2)}` : "$ 0"}
                      </td>
                    </tr>
                  )}

                  {small_order_fee !== 0 && (
                    <tr>
                      <td>Small Order Charge:</td>
                      <td className="text-right" data-testid="small_order_fee">
                        {small_order_fee && !isNaN(small_order_fee) ? `$ ${parseFloat(small_order_fee).toFixed(2)}` : "$ 0"}
                      </td>
                    </tr>
                  )}

                  <tr>
                    <td>GST:</td>
                    <td className="text-right" data-testid="GST">
                      {gst && !isNaN(gst) ? `$ ${parseFloat(gst).toFixed(2)}` : "$ 0"}
                    </td>
                  </tr>

                  <tr className="total-row">
                    <td><strong>Total:</strong></td>
                    <td className="text-right">
                      <strong>
                        {total && !isNaN(total) ? `$ ${parseFloat(total).toFixed(2)}` : "$ 0"}
                      </strong>
                    </td>
                  </tr>
                </tbody>
              </table>
            </Modal.Body>

            <Modal.Footer className="modal-footer no">
              <button
                type="button"
                className="btn btn-danger claim-button btn-block py-0"
                data-dismiss="modal"
                onClick={handleClick}
              >
                Proceed
              </button>
            </Modal.Footer>
          </div>

          :
          <div>
            <Modal.Body className="p-2">
              <div className={`modal-body ${text ? 'modal-background' : ''} d-flex justify-content-center align-items-end`}>
                {/* <div className="modal-body modal-background d-flex justify-content-center align-items-end"> */}
                <button
                  type="button"
                  className="close-modal-btn"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={closeModal}
                >
                  <img src={close} className="exit-img" alt="close" />
                </button>
                <div className="text-white text-center">
                  <div className="font-weight-bold f40 claim">{text}</div>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer className="modal-footer no">
              <button
                type="button"
                className="btn btn-danger claim-button btn-block py-0"
                data-dismiss="modal"
                onClick={closeModal}
              >
                Okay
              </button>
            </Modal.Footer>
          </div>
      }

    </Modal>
  );
};
PopUp.propTypes = {
  closeModal: PropTypes.func.isRequired,
};
export default PopUp;
